export default orderNumber => `
  {
    order(orderNumber: "${orderNumber}") {
      number
      checkoutVersion
      completedAt
      email
      isTaxIncluded
      taxForGoogleAnalytics
      total
      shipmentTotal
      netAmount
      factorToPay
      isNewsletterSubscribed
      state
      shippingAddress {
        firstname
        lastname
        address1
        address2
        zipcode
        city
        state_id
        country_id
        phone
        document_number
        ibge_city_code
        neighborhood
        countryData {
          name
          iso
        }
        stateData {
          abbr
          name
          id
        }
      }
      billingAddress {
        firstname
        lastname
        address1
        address2
        zipcode
        city
        state_id
        country_id
        phone
        document_number
        ibge_city_code
        neighborhood
        countryData {
          name
          iso
        }
        stateData {
          abbr
          name
          id
        }
      }
      shippingRates {
        id
        name
        price
        displayPrice
        selected
        estimatedDelivery
        notice
      }
      items {
        variantId
        sku
        masterSku
        variantSku
        ean
        color
        productName
        productType
        groupName
        imageUrl
        price
        productPath
        quantity
        size
        sizeIdentifier
      }
      promotionAdjustment {
        code
        amount
      }
      taxAdjustments {
        label
        amount
        type
      }
      isPreorder
      preorderDeliveryDate
    }
    currentStore {
      name
      currency {
        code
      }
    }
  }
`
